import { render, staticRenderFns } from "./FindingFormSettings.vue?vue&type=template&id=49e72308&"
import script from "./FindingFormSettings.vue?vue&type=script&lang=js&"
export * from "./FindingFormSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports